import { Box, Typography } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { ISalesByLocation } from "src/types/reports";
import { formatNumber } from "src/utils";

const colors = [
  "#A155B9",
  "#CC9C33",
  "#CC3723",
  "#0075FF",
  "#16AA75",
  "#EB1DB1",
  "#3528C1",
];

const LocationsCarsChart = ({ data }: { data: ISalesByLocation[] }) => {
  const locationsNames: string[] = [];
  const locationsSales: number[] = [];

  let total = 0;

  data?.forEach((item) => {
    locationsNames.push(item.locationName || "");
    locationsSales.push(item.totalTickets || 0);
    total += item.totalTickets;
  });

  const options: ApexCharts.ApexOptions = {
    chart: {
      type: "pie",
      width: 80,
      foreColor: "#FFF",
      redrawOnParentResize: true,
    },
    colors: colors,
    labels: locationsNames,
    noData: {
      style: {
        fontSize: "15px",
      },
      text: "No data available ",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: false,
    },
    tooltip: {
      y: {
        formatter: (value: number): string => formatNumber(+value)?.toString(),
      },
    },
    legend: {
      formatter: function (val, opts) {
        return (
          val +
          " - " +
          (
            (opts.w.globals.series[opts.seriesIndex] / total) * 100 || 0
          ).toFixed(1) +
          "%"
        );
      },
    },
  };

  return (
    <Box
      overflow={"hidden"}
      borderRadius={"12px"}
      height={"100%"}
      bgcolor={"#242424"}
      pb={"10px"}
    >
      <Box bgcolor={"#242424"} padding={"21px 24px"}>
        <Typography fontSize={"20px"} fontWeight={700}>
          Cars Breakdown
        </Typography>
      </Box>
      <Box bgcolor={"#000000"} height={"2px"} />
      <Box height={"100%"} pr={{ xs: "0", md: "150px" }} pb={1} pt={4}>
        <ReactApexChart
          options={options}
          type="pie"
          series={locationsSales}
          width={"100%"}
          height={250}
        />
      </Box>
    </Box>
  );
};

export default LocationsCarsChart;
